import React, { Component } from "react";
import Container from "./styled";
import Pregunta from "./pregunta";
import { Fade } from "react-awesome-reveal";
import { BsWhatsapp } from "react-icons/bs";

export default class Faqs extends Component {
  // Estado que determina si esta abierta o no la question
  state = {
    isActiveUno: false,
    isActiveDos: false,
    isActiveTres: false,
    isActiveCuatro: false,
    isActiveCinco: false,
    isActiveSeis: false,
    isActiveSiete: false,
    isActiveOcho: false,
    isActiveNueve: false,
    isActiveDiez: false,
    isActiveOnce: false,
    isActiveDoce: false,
    isActiveTrece: false,
    isActiveCatorce: false,
  };

  // Toggle generico para cambiar el estado cuando se abre o se cierra cada una de las questions
  handleToggle = (key) => {
    const keys = [
      "Uno",
      "Dos",
      "Tres",
      "Cuatro",
      "Cinco",
      "Seis",
      "Siete",
      "Ocho",
      "Nueve",
      "Diez",
      "Once",
      "Doce",
      "Trece",
      "Catorce",
    ];
    const newState = {};
    keys.forEach((k) => {
      newState[`isActive${k}`] = false;
    });
    const current = this.state[`isActive${key}`];
    newState[`isActive${key}`] = !current;
    this.setState(newState);
  };

  render() {
    return (
      <Container>
        <div id="max-width-container">
          {/* Titulo */}
          <h3>
            <span>Preguntas</span> frecuentes
          </h3>
          {/* Preguntas Container */}
          <div id="preguntas-container">
            {/* Pregunta 1 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveUno == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Cuáles son los requisitos para contratar?"
                clickFunction={() => this.handleToggle("Uno")}
                isActive={this.state.isActiveUno}
              >
                Los requisitos son: Fotos de los 4 lados del auto, foto del
                parabrisas desde el interior, foto de la rueda de auxilio. Todas
                las fotos deben tener la fecha del día en que fueron tomadas. Si
                es Okm, se puede presentar la constancia de no rodamiento.
              </Pregunta>
            </Fade>
            {/* Pregunta 2 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveDos == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Puedo asegurar si el auto no está a nombre mío?"
                clickFunction={() => this.handleToggle("Dos")}
                isActive={this.state.isActiveDos}
              >
                Sí, si el auto no está a tu nombre, igual lo podés asegurar.
              </Pregunta>
            </Fade>
            {/* Pregunta 3 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveTres == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Cuando inicia la vigencia de la póliza?"
                clickFunction={() => this.handleToggle("Tres")}
                isActive={this.state.isActiveTres}
              >
La póliza inicia su vigencia desde las 12hs del día siguiente hábil una vez enviados todos los elementos para emitir el seguro.
              </Pregunta>
            </Fade>
            {/* Pregunta 4 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveCuatro == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="Si el uso es remis, ¿se puede asegurar?"
                clickFunction={() => this.handleToggle("Cuatro")}
                isActive={this.state.isActiveCuatro}
              >
No, no se puede asegurar por medio de las aseguradoras bajo las cuales operamos.
              </Pregunta>
            </Fade>
            {/* Pregunta 5 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveCinco == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Qué significa el tradicional 'terceros completos'?"
                clickFunction={() => this.handleToggle("Cinco")}
                isActive={this.state.isActiveCinco}
              >
                Significa que cubre responsabilidad civil, robo e incendio total
                y parcial, y destrucción total.
              </Pregunta>
            </Fade>
            {/* Pregunta 6 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveSeis == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="Terceros Completo, ¿me cubre contra todo?"
                clickFunction={() => this.handleToggle("Seis")}
                isActive={this.state.isActiveSeis}
              >
Terceros completos no es todo riesgo. Todo riesgo implica cubrir el daño parcial como consecuencia de cualquier daño parcial que sufra el auto .
              </Pregunta>
            </Fade>
            {/* Pregunta 7 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveSiete == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Cuál es la cobertura más completa?"
                clickFunction={() => this.handleToggle("Siete")}
                isActive={this.state.isActiveSiete}
              >
                Son las coberturas que incluye daños parciales: todo riesgo.
              </Pregunta>
            </Fade>
            {/* Pregunta 8 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveOcho == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="En mi auto tengo techo solar de fábrica, ¿se cubre?"
                clickFunction={() => this.handleToggle("Ocho")}
                isActive={this.state.isActiveOcho}
              >
                Sí, los seguros cubren techo solar de fábrica.
              </Pregunta>
            </Fade>
            {/* Pregunta 9 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActivenNueve == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="Si el auto tiene GNC, ¿se puede asegurar?"
                clickFunction={() => this.handleToggle("Nueve")}
                isActive={this.state.isActiveNueve}
              >
                Sí, nos debés informar que el auto tiene GNC, el cual debe estar
                al día para poder asegurarlo.
              </Pregunta>
            </Fade>
            {/* Pregunta 10 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveDiez == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Puede manejar el auto otra persona que no sea el asegurado?"
                clickFunction={() => this.handleToggle("Diez")}
                isActive={this.state.isActiveDiez}
              >
De acuerdo a las normativas vigentes, el auto puede ser conducido por otra persona mientras tenga registro de conducir habilitado.
              </Pregunta>
            </Fade>
            {/* Pregunta 11 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveOnce == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Dónde llamar en caso de siniestro?"
                clickFunction={() => this.handleToggle("Once")}
                isActive={this.state.isActiveOnce}
              >
                Contactate de inmediato con nosotros por whatsapp.{" "}
                <a
                  href="https://api.whatsapp.com/send?phone=541126698544"
                  target="_blank"
                >
                  <span>
                    <BsWhatsapp className="logoMobile" />
                  </span>
                  11 2669 8544
                </a>{" "}
                . teléfono 0810 220 2372 (opción 3)
                {/* <a
                  href="https://api.whatsapp.com/send?phone=541162096951"
                  target="_blank"
                >
                  11 6209 6951
                </a> */}
                , o mandános un mail a:{" "}
                <a id="mailButton" href="mailto:siniestros@seguroweb.com.ar">
                  siniestros@seguroweb.com.ar
                </a>
                . Estaremos acompañándote en todo el proceso hasta el cobro de
                la indemnización.
              </Pregunta>
            </Fade>
            {/* Pregunta 12 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveDoce == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Me cubren el estéreo y la pantalla de la consola central la cual incluye el estero y la computadora del auto?"
                clickFunction={() => this.handleToggle("Doce")}
                isActive={this.state.isActiveDoce}
              >
                En los autos en los cuales el estéreo cumple solo la función de sonido del auto, no está cubierto. Ahora bien, si el auto cuenta con una pantalla la cual incluye funcionalidades del auto, esto es, la computadora de abordo y en la misma incluye la función del stereo, dicha pantalla estará amparada en caso de robo. 
              </Pregunta>
            </Fade>
            {/* Pregunta 13 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveTrece == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title="¿Puedo asegurar el auto si el rodado está a nombre del dueño anterior? Yo ya compre la unidad, la pagué y la tengo en mi poder."
                clickFunction={() => this.handleToggle("Trece")}
                isActive={this.state.isActiveTrece}
              >
Si, se puede, solo que se debe realizar la transferencia para poder tener derecho a cobrar la indemnización  Es de tener cuidado respecto a que si el titular fallece y no se ha realizado la transferencia. En ese caso, el rodado ingresará al proceso sucesorio lo que hará que se demore la indemnización en caso de siniestro el cual implique una baja de unidad en el registro del automotor. 
              </Pregunta>
            </Fade>
            {/* Pregunta 14 */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveCatorce == true
                  ? "pregunta-container-abierta"
                  : "pregunta-container"
              }
            >
              <Pregunta
                title=" ¿Cuándo se retoma la cobertura en caso de mora en el pago de la cuota del seguro?"
                clickFunction={() => this.handleToggle("Catorce")}
                isActive={this.state.isActiveCatorce}
              >
                Una vez abonada la cuota atrasada, se debe presentar fotos fechadas de la unidad. Una vez ello, el seguro inicia nuevamente la cobertura desde las 00hs del día siguiente.
              </Pregunta>
            </Fade>
          </div>
        </div>
      </Container>
    );
  }
}
